import React from 'react'
import ReactDOM from 'react-dom'

import './assets/scss/style.scss'

import './store'

import ProductList from './ProductList'
import ProductDetail from './ProductDetail'
import ProductionProgress from './ProductionProgress'

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept()
}

function renderOrderJourneyProductList(props, element) {
  if (typeof element === 'string') {
    element = document.getElementById(element)
  }

  ReactDOM.render(<ProductList {...props} />, element)
}

function renderOrderJourneyProductDetail(props, element) {
  if (typeof element === 'string') {
    element = document.getElementById(element)
  }

  ReactDOM.render(<ProductDetail {...props} />, element)
}

function renderOrderJourneyProductionProgress(props, element) {
  if (typeof element === 'string') {
    element = document.getElementById(element)
  }

  ReactDOM.render(<ProductionProgress {...props} />, element)
}

function ojaRun() {
  try {
    // Shared to global window.
    window.renderOrderJourneyProductList = renderOrderJourneyProductList
    window.renderOrderJourneyProductDetail = renderOrderJourneyProductDetail
    window.renderOrderJourneyProductionProgress = renderOrderJourneyProductionProgress

    const productList = document.getElementById('oja-area-product-list')
    const productDetail = document.getElementById('oja-area-product-detail')
    const productionProgress = document.getElementById(
        'oja-area-production-progress')

    if (!productList && !productDetail && !productionProgress) {
      console.warn(
          'No elements [#oja-area-product-list, #oja-area-product-detail, #oja-area-production-progress] was found in the document',
      )
    }

    if (productList) {
      renderOrderJourneyProductList({}, productList)
    }

    if (productDetail) {
      if (!productDetail.getAttribute('data-product')) {
        console.warn('No product provide!')
      }

      renderOrderJourneyProductDetail(
          {
            product: productDetail.getAttribute('data-product'),
          },
          productDetail,
      )
    }

    if (productionProgress) {
      if (!productionProgress.getAttribute('data-order-id')) {
        console.warn('No order id provide!')
      }

      renderOrderJourneyProductionProgress(
          {
            orderId: productionProgress.getAttribute('data-order-id'),
          },
          productionProgress,
      )
    }
  } catch (e) {
    console.log('Errrrrorrrr: ' + e)
  }
}

setTimeout(ojaRun, 0)